import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { CloseDialog, OpenDialog, SendBookClubHistory } from './bookclub-links.actions';
import { patch } from '@ngxs/store/operators';
import { ExperienceModel } from 'src/app/models/experience-link';
import { BookclubLinksDialogFactory } from './services/bookclub-links.factory';
import { BookclubHistoryApiService } from 'src/app/services/api/bookclub-history-api.service';
import { UserService } from 'src/app/services/user.service';
import { finalize, tap } from 'rxjs';
import { openWindow } from 'src/app/_core/utils/open-window';

export type BookclubLinksStateModel = {
  title: string;
  links: ExperienceModel[];
  resourceId: string;
  open: boolean;
};

export const initialState: BookclubLinksStateModel = {
  title: '',
  links: [],
  resourceId: '',
  open: false,
};

@State<BookclubLinksStateModel>({
  name: 'bookclubLinks',
  defaults: initialState,
})
@Injectable()
export class BookclubLinksState {

  private readonly userService = inject(UserService);
  private readonly bookclubLinksDialogFactory = inject(BookclubLinksDialogFactory);
  private readonly bookClubHistoryService = inject(BookclubHistoryApiService);

  @Selector()
  static open(state: BookclubLinksStateModel): boolean {
    return state.open;
  }

  @Selector()
  static title(state: BookclubLinksStateModel): string {
    return state.title;
  }

  @Selector()
  static links(state: BookclubLinksStateModel): ExperienceModel[] {
    return state.links.filter((link) => link.experienceLinks.length);
  }

  @Selector()
  static resourceId(state: BookclubLinksStateModel): string {
    return state.resourceId;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<BookclubLinksStateModel>, { title, links, resourceId }: OpenDialog) {
    context.setState(
      patch({
        open: true,
        title,
        links: this.bookclubLinksDialogFactory.buildLinks(links),
        resourceId,
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<BookclubLinksStateModel>) {
    context.setState(initialState);
  }

  @Action(SendBookClubHistory)
  sendBookClubHistory(context: StateContext<BookclubLinksStateModel>, { recordId, link, dontShow }: SendBookClubHistory) {
    return this.bookClubHistoryService.saveBookClubHistory(
      this.userService.getUserId(),
      recordId,
      link.learningExperienceId,
      dontShow).pipe(
        tap(() => {
          openWindow(link.url);
        }),
        finalize(() => {
          context.setState(initialState);
        })
      );
  }
}
